var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4",staticStyle:{"margin-left":"30px"}},[_c('EmbeddedMedia',{attrs:{"media-type":"category","value":_vm.itemDashboard,"show-controls":!_vm.tabbed,"parent":_vm.item},on:{"save":function($event){return _vm.$emit('save', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }